import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full min-h-[41px] px-2 rounded-primary-radius bg-[#E5E4E2] grid grid-cols-5 gap-3 lg:gap-0 items-center" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_10 = { class: "w-full h-[440px] 2xl:h-[640px] overflow-y-scroll flex flex-col gap-2" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "text-primary-text-color text-sm font-normal leading-[20px] break-all" }
const _hoisted_13 = { class: "flex items-center pr-2" }
const _hoisted_14 = { class: "flex items-center pr-2" }
const _hoisted_15 = {
  class: "text-primary-text-color px-[6px] py-[2px] rounded-primary-radius text-sm font-medium tracking-[0.01rem]",
  style: `background-color: #FCD3AC`
}
const _hoisted_16 = { class: "flex flex-col items-start custom-lg:flex-row custom-lg:items-center gap-1" }
const _hoisted_17 = { class: "text-primary-text-color text-sm font-normal leading-[20px]" }
const _hoisted_18 = { class: "text-primary-text-color text-sm font-normal leading-[20px]" }
const _hoisted_19 = { class: "flex flex-wrap items-center gap-1" }

import { useTranslate } from "@/composables/useTranslate";
import { InstallationTermin } from "@/types";
import { getTerminStatusColor } from "@/utils/status-color";


type Props = {
  termins?: InstallationTermin[];
};

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallerProfileTable',
  props: {
    termins: {}
  },
  setup(__props: any) {

const { t } = useTranslate();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("installers.table_column_name")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("installers.table_column_status")), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("span", { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }, "QC Status")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("installers.table_column_date")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("installers.table_column_teammates")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.termins, (appointment, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: appointment.id,
          class: _normalizeClass(["w-full rounded-primary-radius py-3 px-2 bg-white grid grid-cols-5 gap-3 lg:gap-0 items-center", index === 0 ? 'mt-3' : 'mt-0'])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(appointment.name ? appointment.name : "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: "text-[#393840] px-[6px] py-[2px] rounded-primary-radius text-xs font-medium tracking-[0.01rem]",
              style: _normalizeStyle(`background: ${_unref(getTerminStatusColor)(appointment.status?.id)}`)
            }, _toDisplayString(appointment.status?.name
              ? appointment.status?.name.charAt(0).toUpperCase() +
                appointment.status?.name.slice(1)
              : "-"), 5)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(appointment.qc_status ? appointment.qc_status.name : "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(appointment.start
              ? new Date(appointment.start).toLocaleDateString("DE")
              : "-"), 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-primary-text-color text-sm font-normal leading-[20px]" }, "-", -1)),
            _createElementVNode("span", _hoisted_18, _toDisplayString(appointment.end
              ? new Date(appointment.end).toLocaleDateString("DE")
              : "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.workers, (worker, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "text-primary-text-color text-sm font-normal break-all",
                key: index
              }, _toDisplayString(worker.name), 1))
            }), 128))
          ])
        ], 2))
      }), 128))
    ])
  ], 64))
}
}

})